<template>
  <base-amount
    :unit="'%'"
    :value="value"
    :options="{ minimumFractionDigits: 0, maximumFractionDigits: 3 }"
  ></base-amount>
</template>

<script>
import BaseAmount from '@kanrisha/components/Elements/Amount/BaseAmount';

export default {
  components: {
    BaseAmount,
  },
  props: {
    unit: { type: String, default: () => null },
    value: { type: [Number, String], default: () => 0.0 },
    schema: { type: String, default: '{{ unit }}{{ value }}' },
  },
  setup() {
    return {};
  },
};
</script>
